import { render, staticRenderFns } from "./ModalPracticeCatalog.vue?vue&type=template&id=583b8344&scoped=true&lang=pug"
import script from "./ModalPracticeCatalog.vue?vue&type=script&lang=js"
export * from "./ModalPracticeCatalog.vue?vue&type=script&lang=js"
import style0 from "./ModalPracticeCatalog.vue?vue&type=style&index=0&id=583b8344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583b8344",
  null
  
)

export default component.exports